import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './style.css';


export default class ValueViewer extends React.Component {

  static propTypes = {
    readOnly: PropTypes.bool.isRequired,
    makeEditable: PropTypes.func.isRequired,
    emptyText: PropTypes.node.isRequired,
    children: PropTypes.node,
    extraOperations: PropTypes.node
  };

  static defaultProps = {
    readOnly: false,
    makeEditable: () => null,
    emptyText: 'Unknown',
    extraOperations: null
  };

  constructor() {
    super(...arguments);
    this.handleClick = this.handleClick.bind(this);
  }

  handleClick(e) {
    e.preventDefault();
    this.props.makeEditable();
  }

  render() {
    let {
      readOnly, children, emptyText,
      className, extraOperations, ...props} = this.props;
    className = classNames(className, style.valueViewer);
    if (readOnly) {
      className = classNames(className, style.readOnly);
    }

    delete props.makeEditable;
    return(
      <div
       {...props}
       onDoubleClick={readOnly ? null : this.handleClick}
       className={className}>
        {children ? children :
        <span className={style.trivia}>{emptyText}</span>}
        <span className={style.pullRight}>
          {extraOperations}
          {readOnly ? null : <a href="#" onClick={this.handleClick}>
             (edit)
           </a>}
        </span>
      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/views/fragments/forms/value-viewer.js